import React from 'react';
import type { RecipeData, RecipeResult } from 'types/Recipes';
import NextImage from 'components/NextImage';
import { ImagesService } from 'service/images/imagesService';
import { RecipeHeaderPrint } from './components/RecipeHeaderPrint';
import { IngredientsPrint } from './components/IngredientsRrint';
import RecipeFooterPrint from '../../RecipeFooterPrint';
import { RecipeStepPrint } from './components/RecipeStepPrint';

interface ClientRecipesSlugPagePrintProps {
  logo: string;
  recipe?: RecipeResult;
  recipeData?: RecipeData;
}

const ClientRecipesSlugPagePrint = ({
  logo,
  recipe,
  recipeData,
}: ClientRecipesSlugPagePrintProps) => {
  const dictionary = recipeData?.titles?.dictionaryItems;
  const preparationBlocks = recipe?.ClassicInstruction?.PreparationBlocks;

  return (
    <>
      <table className="table-container mt-8 hidden print:block w-full">
        <tbody className="pb-[80px] break-after-avoid ">
          <tr className="">
            <td className="!px-16">
              <div className="flex flex-row">
                <RecipeHeaderPrint recipe={recipe} logo={logo} dictionary={dictionary} />

                <div className="h-[192px] grow flex items-end">
                  <NextImage
                    className="object-cover rounded-lg"
                    width={325}
                    height={192}
                    src={ImagesService.getRecipeImageForHeroBanner(recipe)?.desktop}
                    alt="Hero image"
                    priority
                  />
                </div>
              </div>

              <IngredientsPrint recipe={recipe} dictionary={dictionary} />

              <RecipeStepPrint steps={preparationBlocks} dictionary={dictionary as any} />
            </td>
          </tr>
        </tbody>
        <tfoot className="table-footer break-after-avoid ">
          <tr className="w-full">
            <td className="flex">
              <div className="h-[80px]">&nbsp;</div>
              <RecipeFooterPrint recipeData={recipeData} />
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default ClientRecipesSlugPagePrint;
